/* js/print-feature.js */
/* WellyTails Print & Email Feature */

async function generatePdf(htmlContent, fileName = null) {
    const { jsPDF } = window.jspdf;
    const printContainer = document.createElement('div');
    printContainer.style.position = 'absolute';
    printContainer.style.left = '-9999px';
    printContainer.style.top = '0';
    printContainer.style.width = '1400px';
    printContainer.style.minHeight = '900px';
    printContainer.innerHTML = htmlContent;
    document.body.appendChild(printContainer);

    await new Promise(resolve => setTimeout(resolve, 100));

    const canvas = await html2canvas(printContainer, {
        scale: 2,
        useCORS: true,
        logging: false,
        width: 1400,
        windowWidth: 1400,
        backgroundColor: '#ffffff'
    });
    document.body.removeChild(printContainer);

    const pdf = new jsPDF({
        orientation: 'landscape',
        unit: 'mm',
        format: 'a4',
        compress: true
    });

    const imgData = canvas.toDataURL('image/jpeg', 0.80);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();
    
    const margin = 5;
    const availableWidth = pdfWidth - (margin * 2);
    const availableHeight = pdfHeight - (margin * 2);
    
    const canvasAspectRatio = canvas.height / canvas.width;
    let finalWidth = availableWidth;
    let finalHeight = availableWidth * canvasAspectRatio;

    if (finalHeight > availableHeight) {
        finalHeight = availableHeight;
        finalWidth = finalHeight / canvasAspectRatio;
    }
    
    const xOffset = (pdfWidth - finalWidth) / 2;
    const yOffset = (pdfHeight - finalHeight) / 2;

    pdf.addImage(imgData, 'JPEG', xOffset, yOffset, finalWidth, finalHeight, '', 'FAST');
    
    // If fileName provided, download it. Otherwise, return blob
    if (fileName) {
        pdf.save(fileName);
    } else {
        return pdf.output('blob');
    }
}

// ==================== PRINT FEATURE ====================

async function printWellyTailsRecipe() {
    const printButton = document.getElementById('print-btn');
    const originalButtonText = printButton.innerHTML;
    printButton.disabled = true;
    printButton.innerHTML = '🔄 Generating PDF...';

    const printData = collectPrintData();
    if (!printData.recipeKey) {
        alert('Please select a recipe and calculate results before printing.'); 
        printButton.disabled = false;
        printButton.innerHTML = originalButtonText;
        return; 
    }

    try {
        const printHTML = await generateCompleteExcelPrintHTML(printData);
        await generatePdf(printHTML, `WellyTails-Recipe-${printData.dogName}.pdf`);  // ← Pass fileName
    } catch (error) {
        console.error("Failed to generate or download PDF:", error);
        alert("Sorry, there was an error creating the PDF. Please try again.");
    } finally {
        printButton.disabled = false;
        printButton.innerHTML = originalButtonText;
    }
}

// ==================== EMAIL FEATURE ====================

async function emailWellyTailsRecipe() {
    const printData = collectPrintData();
    if (!printData.recipeKey) {
        alert('Please select a recipe and calculate results before emailing.');
        return;
    }
    
    showEmailModal();
}

function showEmailModal() {
    document.getElementById('email-modal-overlay').style.display = 'flex';
    document.getElementById('recipient-email').focus();
}

function hideEmailModal() {
    document.getElementById('email-modal-overlay').style.display = 'none';
    document.getElementById('recipient-email').value = '';
    const statusDiv = document.getElementById('email-status');
    statusDiv.style.display = 'none';
}

async function sendEmail() {
    const recipientEmail = document.getElementById('recipient-email').value.trim();
    const statusDiv = document.getElementById('email-status');
    
    // Validation
    if (!recipientEmail || !recipientEmail.includes('@')) {
        statusDiv.style.display = 'block';
        statusDiv.style.background = '#ffebee';
        statusDiv.style.color = '#c62828';
        statusDiv.textContent = '⚠️ Please enter a valid email address';
        return;
    }
    
    const sendButton = document.getElementById('send-email-btn');
    const originalText = sendButton.textContent;
    sendButton.disabled = true;
    sendButton.textContent = 'Sending...';
    
    statusDiv.style.display = 'block';
    statusDiv.style.background = '#fff3cd';
    statusDiv.style.color = '#856404';
    statusDiv.textContent = '⏳ Generating PDF...';
    
    try {
        const printData = collectPrintData();
        const printHTML = await generateCompleteExcelPrintHTML(printData);
        
        // Generate PDF as Blob (no fileName = returns blob)
        statusDiv.textContent = '⏳ Creating PDF...';
        const pdfBlob = await generatePdf(printHTML);  // ← No fileName = returns blob
        const fileName = `WellyTails-Recipe-${printData.dogName}.pdf`;
        
        // Upload to Cloudinary
        statusDiv.textContent = '☁️ Uploading PDF...';
        const pdfUrl = await uploadPdfToCloudinary(pdfBlob, fileName);
        
        // Send email via EmailJS
        statusDiv.textContent = '📧 Sending email...';
        await emailjs.send(
            window.wellytails_config.emailjs.serviceId,
            window.wellytails_config.emailjs.templateId,
            {
                to_email: recipientEmail,
                dog_name: printData.dogName,
                download_link: pdfUrl,
                file_name: fileName
            }
        );
        
        statusDiv.style.background = '#e8f5e9';
        statusDiv.style.color = '#2e7d32';
        statusDiv.textContent = '✅ Email sent successfully! Check your inbox.';
        
        setTimeout(() => {
            hideEmailModal();
        }, 3000);
        
    } catch (error) {
        console.error('Email error:', error);
        statusDiv.style.background = '#ffebee';
        statusDiv.style.color = '#c62828';
        statusDiv.textContent = '❌ Failed to send email. Please try again.';
    } finally {
        sendButton.disabled = false;
        sendButton.textContent = originalText;
    }
}

async function uploadPdfToCloudinary(pdfBlob, fileName) {
    const formData = new FormData();
    formData.append('file', pdfBlob, fileName);
    formData.append('upload_preset', window.wellytails_config.cloudinary.uploadPreset);
    formData.append('folder', 'wellytails-recipes');
    
    const response = await fetch(
        `https://api.cloudinary.com/v1_1/${window.wellytails_config.cloudinary.cloudName}/raw/upload`,
        {
            method: 'POST',
            body: formData
        }
    );
    
    if (!response.ok) {
        throw new Error('Failed to upload PDF to Cloudinary');
    }
    
    const data = await response.json();
    return data.secure_url;
}

// ==================== EVENT LISTENERS ====================

document.addEventListener("click", (e) => {
    if (e.target && e.target.id === "print-btn") {
        printWellyTailsRecipe();
    }
    if (e.target && e.target.id === "email-btn") {
        emailWellyTailsRecipe();
    }
    if (e.target && e.target.id === "send-email-btn") {
        sendEmail();
    }
    if (e.target && e.target.id === "cancel-email-btn") {
        hideEmailModal();
    }
    if (e.target && e.target.id === "email-modal-overlay") {
        if (e.target === document.getElementById('email-modal-overlay')) {
            hideEmailModal();
        }
    }
});

// ==================== SHARED FUNCTIONS ====================

function collectPrintData() {
    const recipeSelect = document.getElementById('recipe-select'); 
    const selectedRecipeKey = recipeSelect?.value || '';
    const selectedOption = recipeSelect?.options[recipeSelect.selectedIndex]; 
    const recipeName = selectedOption?.text || selectedRecipeKey; 
    
    return {
        dogName: document.getElementById('dog-name')?.value || 'Your Dog', 
        weight: parseFloat(document.getElementById('dog-weight')?.value) || 0, 
        weightUnit: document.getElementById('weight-unit')?.value || 'lbs', 
        lifestyle: document.getElementById('lifestyle-select')?.value || '', 
        recipeKey: selectedRecipeKey,
        recipeName: recipeName,
        selectedMode: document.querySelector('input[name="calculation-mode"]:checked')?.value || 'days', 
        numDays: parseInt(document.getElementById('num-days')?.value) || 7, 
        meatAmount: parseFloat(document.getElementById('meat-amount')?.value) || 0, 
        meatCost: parseFloat(document.getElementById('meat-cost')?.value) || 0, 
        estimatedCalories: parseFloat(document.getElementById('estimated-calories')?.textContent) || 0, 
        calorieOverride: parseFloat(document.getElementById('calorie-override')?.value) || null, 
        currentDate: new Date().toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short', 
            day: 'numeric'
        })
    }; 
}

async function generateCompleteExcelPrintHTML(data) {
    let recipeData; 
    try {
        const response = await fetch(window.wellytails_calc_assets.recipes_url); 
        if (!response.ok) {
            throw new Error('Failed to load recipes.json'); 
        }
        const jsonData = await response.json(); 
        recipeData = jsonData[data.recipeKey]; 
    } catch (error) {
        console.error('Error loading recipes.json:', error); 
        return '<html><body><h1>Error: Could not load recipe data</h1></body></html>'; 
    }
    
    if (!recipeData) {
        return '<html><body><h1>Error: Recipe data not found for ' + data.recipeKey + '</h1></body></html>'; 
    }
    
    const targetCalories = data.calorieOverride || data.estimatedCalories; 
    const dailyFoodGrams = (targetCalories / recipeData.meKcalKg) * 1000; 
    
    let batchInfo = ''; 
    let costInfo = '';
    
    if (data.selectedMode === 'days') {
        const totalFoodG = dailyFoodGrams * data.numDays; 
        const totalMeatG = totalFoodG * (recipeData.meatGrams / 1000); 
        const totalBaseMixG = totalFoodG * (recipeData.baseMixGrams / 1000); 
        const totalWaterG = totalFoodG * (recipeData.waterGrams / 1000); 
        const totalMeatLbs = totalMeatG * 0.00220462; 
        
        batchInfo = `
            <tr><td><strong>Meat</strong></td><td>${Math.round(totalMeatG)}g</td><td>${totalMeatLbs.toFixed(1)}lbs</td><td>${((totalMeatG/totalFoodG)*100).toFixed(1)}%</td></tr>
            <tr><td><strong>Base Mix</strong></td><td>${Math.round(totalBaseMixG)}g</td><td>${(totalBaseMixG*0.00220462).toFixed(1)}lbs</td><td>${((totalBaseMixG/totalFoodG)*100).toFixed(1)}%</td></tr>
            <tr><td><strong>Water</strong></td><td>${Math.round(totalWaterG)}g</td><td>${(totalWaterG*0.00220462).toFixed(1)}lbs</td><td>${((totalWaterG/totalFoodG)*100).toFixed(1)}%</td></tr>
            <tr style="background: #e8f5e9; font-weight: bold;"><td><strong>TOTAL</strong></td><td>${Math.round(totalFoodG)}g</td><td>${(totalFoodG*0.00220462).toFixed(1)}lbs</td><td>100%</td></tr>
        `; 
        
        if (data.meatCost > 0) {
            const totalCost = totalMeatLbs * data.meatCost; 
            costInfo = `<div class="cost-info">Estimated Cost: $${totalCost.toFixed(2)} (at $${data.meatCost.toFixed(2)}/lb)</div>`; 
        }
    } else {
        const userMeatG = data.meatAmount / 0.00220462; 
        const totalFoodG = userMeatG / (recipeData.meatGrams / 1000); 
        const totalBaseMixG = totalFoodG * (recipeData.baseMixGrams / 1000); 
        const totalWaterG = totalFoodG * (recipeData.waterGrams / 1000); 
        
        batchInfo = `
            <tr><td><strong>Meat</strong></td><td>${Math.round(userMeatG)}g</td><td>${data.meatAmount.toFixed(1)}lbs</td><td>${((userMeatG/totalFoodG)*100).toFixed(1)}%</td></tr>
            <tr><td><strong>Base Mix</strong></td><td>${Math.round(totalBaseMixG)}g</td><td>${(totalBaseMixG*0.00220462).toFixed(1)}lbs</td><td>${((totalBaseMixG/totalFoodG)*100).toFixed(1)}%</td></tr>
            <tr><td><strong>Water</strong></td><td>${Math.round(totalWaterG)}g</td><td>${(totalWaterG*0.00220462).toFixed(1)}lbs</td><td>${((totalWaterG/totalFoodG)*100).toFixed(1)}%</td></tr>
            <tr style="background: #e8f5e9; font-weight: bold;"><td><strong>TOTAL</strong></td><td>${Math.round(totalFoodG)}g</td><td>${(totalFoodG*0.00220462).toFixed(1)}lbs</td><td>100%</td></tr>
        `; 
    }

    try {
        const response = await fetch(window.wellytails_calc_assets.print_template_url);
        if (!response.ok) {
            throw new Error('Failed to load print template'); 
        }
        let template = await response.text();

        template = template.replace('calc-print.css', window.wellytails_calc_assets.print_css_url);

        const replacements = {
            dogName: data.dogName,
            currentDate: data.currentDate,
            weight: data.weight,
            weightUnit: data.weightUnit,
            lifestyle: formatLifestyleCompact(data.lifestyle),
            targetCalories: Math.round(targetCalories), 
            formulaName: recipeData.formulaName,
            waterName: recipeData.ingredients.water.name || 'Water', 
            waterAmount: recipeData.ingredients.water.amount,
            waterPercent: recipeData.ingredients.water.percent,
            meatName: recipeData.ingredients.meat.name,
            meatAmount: recipeData.ingredients.meat.amount,
            meatPercent: recipeData.ingredients.meat.percent,
            baseMixName: recipeData.ingredients.baseMix.name,
            baseMixAmount: recipeData.ingredients.baseMix.amount,
            baseMixPercent: recipeData.ingredients.baseMix.percent, 
            dailyFoodGrams: Math.round(dailyFoodGrams),
            batchDuration: data.selectedMode === 'days' ? `${data.numDays} days` : `${(data.meatAmount / 0.00220462 / (dailyFoodGrams * (recipeData.meatGrams / 1000))).toFixed(1)} days`, 
            batchInfo: batchInfo,
            costInfo: costInfo,
            dryMatterUnits: recipeData.nutrition.dryMatter.units,
            dryMatterAmount: recipeData.nutrition.dryMatter.amount,
            moistureUnits: recipeData.nutrition.moisture.units,
            moistureAmount: recipeData.nutrition.moisture.amount,
            crudeProteinUnits: recipeData.nutrition.crudeProtein.units, 
            crudeProteinAmount: recipeData.nutrition.crudeProtein.amount,
            crudeProteinDmb: recipeData.nutrition.crudeProtein.dmb,
            crudeProteinPer1000kcal: recipeData.nutrition.crudeProtein.per1000kcal,
            crudeFatUnits: recipeData.nutrition.crudeFat.units,
            crudeFatAmount: recipeData.nutrition.crudeFat.amount,
            crudeFatDmb: recipeData.nutrition.crudeFat.dmb,
            crudeFatPer1000kcal: recipeData.nutrition.crudeFat.per1000kcal, 
            ashUnits: recipeData.nutrition.ash.units,
            ashAmount: recipeData.nutrition.ash.amount,
            ashDmb: recipeData.nutrition.ash.dmb,
            ashPer1000kcal: recipeData.nutrition.ash.per1000kcal,
            crudeFiberUnits: recipeData.nutrition.crudeFiber.units,
            crudeFiberAmount: recipeData.nutrition.crudeFiber.amount,
            crudeFiberDmb: recipeData.nutrition.crudeFiber.dmb, 
            crudeFiberPer1000kcal: recipeData.nutrition.crudeFiber.per1000kcal,
            carbohydrateUnits: recipeData.nutrition.carbohydrate.units,
            carbohydrateAmount: recipeData.nutrition.carbohydrate.amount,
            carbohydrateDmb: recipeData.nutrition.carbohydrate.dmb,
            carbohydratePer1000kcal: recipeData.nutrition.carbohydrate.per1000kcal,
            meUnits: recipeData.nutrition.me.units,
            meAmount: recipeData.nutrition.me.amount, 
            meDmb: recipeData.nutrition.me.dmb,
            caloriesProtein: recipeData.calorieBreakdown.protein,
            caloriesFat: recipeData.calorieBreakdown.fat,
            caloriesCarbohydrates: recipeData.calorieBreakdown.carbohydrates
        }; 

        for (const [key, value] of Object.entries(replacements)) {
            template = template.replace(new RegExp(`{{${key}}}`, 'g'), value); 
        }

        return template; 
    } catch (error) {
        console.error('Error loading print template:', error); 
        return '<html><body><h1>Error: Could not load print template</h1></body></html>'; 
    }
}

function formatLifestyleCompact(lifestyle) {
    const lifestyleMap = {
        'puppy_small': 'Puppy (Small)',
        'puppy_large': 'Puppy (Large)', 
        'adult': 'Adult',
        'active': 'Active',
        'inactive': 'Senior'
    }; 
    return lifestyleMap[lifestyle] || lifestyle;
}